
import { Component, Mixins } from "vue-property-decorator";
import { IConfiguration } from "../../../../../domain/configuration";
import { IObjectStyleReadable } from "../../IObjectStyleReadable";
import { ColorFixedTextObjectStyleReader } from "../../styleReaders";
import { default as StyledTextEditableObjectMixin } from "./StyledTextEditableObjectMixin.vue";
import { TextBoxItem } from "../../../../../domain/document/items";

@Component({
})
export default class RangeOfMotionTextEditableObjectMixin extends Mixins(
  StyledTextEditableObjectMixin,
) {
  data(): any {
    return {
      isInputting: false,
    };
  }
  isInputting: boolean;

  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new ColorFixedTextObjectStyleReader(configuration.style.document.editor.objects.rangeOfMotionTextBox);
  }

  get currentPaintStyleProperties(): any {
    return this.isInputting
      ? this.paintStyleProperties
      : this.idlePaintStyleProperties;
  }

  get idlePaintStyleProperties(): any {
    return {
      backgroundColor: "transparent",
    };
  }

  get valueSource(): string {
    return this.readPropertyOrDefault(s => s.value, "");
  }

  set valueSource(value: string) {
    this.writePropertyWhenValid((s: TextBoxItem) => {
      s.value = value;
      s.adjustFontSize();
    });
  }
}
